export const FETCH_ADMIN_INFO = 'FETCH_ADMIN_INFO';

export const fetchadmininfo = (admininfo) => {
  console.log("admininfo", admininfo); 
  return {
    type: FETCH_ADMIN_INFO,
    payload: admininfo,
  };
};
